import { Box } from '@material-ui/core';
import React, { useState } from 'react';
import Input from '../atoms/input';
import { useForm } from 'react-hook-form';
import './styles.scss';
import ButtonComponent from '../atoms/button';
import FretappLogoWhite from '../../assets/images/fretapp-logo-white';
import { useHistory } from 'react-router-dom';
import { ResetPasswordForm } from '../../services/types';
import useResetPassword from '../../hooks/account/useResetPassword';
import Typography from '../atoms/typography';

const ResetPassword: React.FC = () => {
  const { control } = useForm();
  const history = useHistory();
  const [valuesResetPasswordForm, setValuesResetPasswordForm] =
    useState<ResetPasswordForm>({
      token: '',
      email: '',
      password: '',
      confirmPassword: '',
    });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState(false);
  const { execute, loading } = useResetPassword();

  const onNavigationClick = (path: string) => {
    history.push(path);
  };

  const onPageLogin = () => {
    onNavigationClick(`/admin/login`);
  };

  const handleChange = (field: keyof ResetPasswordForm, value: string) => {
    setValuesResetPasswordForm(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmitResetPassword = async (
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    event.preventDefault();

    const { token, email, password, confirmPassword } = valuesResetPasswordForm;

    if (
      [token, email, password, confirmPassword].some(
        field => field.trim() === '',
      )
    ) {
      setErrorMessage('Todos os campos são obrigatórios');
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage('As senhas não são iguais');
      return;
    }

    if (password.length < 6) {
      setErrorMessage('A senha deve ter no mínimo 6 caracteres');
      return;
    }

    setErrorMessage('');

    try {
      await execute(token, password, email);
      setSuccessMessage(true);
    } catch (error) {
      setErrorMessage('Ocorreu um erro ao alterar a senha. Tente novamente.');
    }
  };

  return (
    <Box className="reset-password-container">
      <Box className="modal-password">
        <Box>
          <FretappLogoWhite className="logo" />
        </Box>

        {!successMessage ? (
          <Box>
            <p className="paragraph">
              Insira o código enviado para o seu email cadastrado e complete os
              demais campos para realizar a alteração de senha.
            </p>
            <form onSubmit={handleSubmitResetPassword} className="box-form">
              <Input
                name="token"
                label="Código de verificação"
                type="number"
                placeholder="Digite o código de verificação"
                control={control}
                labelColor="white"
                className="input"
                value={valuesResetPasswordForm.token}
                onChange={e => handleChange('token', e.target.value)}
              />
              <Box mt={1} />
              <Input
                name="password"
                label="Nova senha"
                type="password"
                labelColor="white"
                control={control}
                placeholder="Digite sua nova senha"
                value={valuesResetPasswordForm.password}
                onChange={e => handleChange('password', e.target.value)}
              />
              <Box mt={1} />

              <Input
                name="confirmPassword"
                label="Confirmação da nova senha"
                type="password"
                labelColor="white"
                control={control}
                placeholder="Digite sua senha novamente"
                value={valuesResetPasswordForm.confirmPassword}
                onChange={e => handleChange('confirmPassword', e.target.value)}
              />

              <Box mt={1} />

              <Input
                name="email"
                label="Email"
                placeholder="Digite seu email"
                control={control}
                labelColor="white"
                className="input"
                value={valuesResetPasswordForm.email}
                onChange={e => handleChange('email', e.target.value)}
              />
              <Box mt={2} />
              {errorMessage && (
                <p style={{ color: 'white', fontSize: 14 }}>{errorMessage}</p>
              )}
              <ButtonComponent
                flex={1}
                theme="secondary"
                loading={loading}
                type="submit"
              >
                Alterar senha
              </ButtonComponent>
            </form>
          </Box>
        ) : (
          <Box>
            <p className="title">Pronto!</p>
            <Typography color="white">
              A nova senha foi configurada com sucesso, agora você pode acessar
              a plataforma sem problemas.
            </Typography>
            <Box mt={2} />
            <Typography color="white">
              Estamos à disposição para oferecer suporte. Se precisar de ajuda,
              entre em contato conosco.
            </Typography>
            <Box mt={2} />
            <ButtonComponent
              theme="secondary"
              loading={loading}
              onClick={onPageLogin}
            >
              Acessar
            </ButtonComponent>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ResetPassword;
